import React from 'react';
import {
  FaCertificate,
  FaClipboardList,
  FaFileAlt,
  FaChalkboardTeacher,
  FaHardHat,
  FaUsers,
} from 'react-icons/fa';
import {
  //   AchievementsSection,
  AchievementGrid,
  AchievementCard,
} from './Achievements.styles';
// import { SectionHeader } from '../About.styles';

const Achievements = () => {
  return (
    <AchievementGrid>
      <AchievementCard>
        <FaCertificate />
        <h4>Advanced Safety Training</h4>
        <p>
          Completed Modern Safety Management training with DuPont, along with
          additional professional development throughout a long career in
          occupational health and safety.
        </p>
      </AchievementCard>

      <AchievementCard>
        <FaClipboardList />
        <h4>Audit Criteria Development</h4>
        <p>
          Developed audit criteria for a variety of operations, helping
          businesses evaluate safety performance and strengthen internal
          systems.
        </p>
      </AchievementCard>

      <AchievementCard>
        <FaFileAlt />
        <h4>OSH Policy Development</h4>
        <p>
          Significant experience developing occupational health and safety
          policies, procedures, and workplace safety documentation.
        </p>
      </AchievementCard>

      <AchievementCard>
        <FaChalkboardTeacher />
        <h4>Custom Training Courses</h4>
        <p>
          Designed safety training courses tailored to specific industry
          requirements, client needs, and workplace conditions.
        </p>
      </AchievementCard>

      <AchievementCard>
        <FaHardHat />
        <h4>Site Inspections</h4>
        <p>
          Certified trainer and site inspector with experience patrolling and
          inspecting worksites for compliance.
        </p>
      </AchievementCard>

      <AchievementCard>
        <FaUsers />
        <h4>Workplace Committee Support</h4>
        <p>
          Assisted with toolbox talks, tailgate meetings, JOSH committee
          meetings, and Department of Labour order compliance.
        </p>
      </AchievementCard>
    </AchievementGrid>
  );
};

export default Achievements;
